import api from './api'

const employeeService = {
  getAll: (params) => {
    return api.get('/employees', { params })
  },

  getEmployees: (params) => {
    return api.get('/employees', { params })
  },

  getById: (id) => {
    return api.get(`/employees/${id}`)
  },

  create: (data) => {
    return api.post('/employees/create', data)
  },

  update: (id, data) => {
    return api.post(`/employees/${id}/update`, data)
  },

  delete: (id) => {
    return api.post(`/employees/${id}/delete`)
  },

  getOrgChart: (params) => {
    return api.get('/employees/orgchart', { params })
  },

  getSubordinates: (id) => {
    return api.get(`/employees/${id}/subordinates`)
  },
}

export default employeeService
